<template>
    <div>
        <rkm-row>

            <rkm-col cols="6">
                <rkm-area
                    title="Peso"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col>
                            <rkm-form-select
                                :options="form.peso"
                                label="Qual a condição?"
                                show-default-option
                                text-field="descricao"
                                v-model="model.pesoId"
                                default-option-text="Selecione"
                                value-field="id"
                                inline
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Internação nos últimos 12 meses"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-radio-group
                                v-model="model.internacao"
                                label="Teve internação?"
                                @change="resetInternacaoMotivo()"
                                :disabled="model.recusaCadastro"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-input
                                label="Motivo"
                                v-model="model.internacaoMotivo"
                                :disabled="!model.internacao || model.recusaCadastro"
                                :validations="model.internacao == true ? validations.internacaoMotivo : {}"
                                uppercase
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                label="Data"
                                :max-date="form.dataAtual"
                                :min-date="minDate"
                                v-model="model.internacaoData"
                                :validations="model.internacao == true ? validations.internacao : {}"
                                :disabled="!model.internacao || model.recusaCadastro"
                                right
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Doença cardíaca/do coração"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-radio-group
                                v-model="model.doencaCardiaca"
                                label="Tem?"
                                @change="resetDoencaCardiacaQuais()"
                                :disabled="model.recusaCadastro"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="8">
                            <rkm-form-checkbox-group
                                :options="form.doencasCardiacas"
                                label="Quais doenças cardíacas?"
                                name="doencasCardiacas"
                                text-field="descricao"
                                v-model="model.doencaCardiacaQuais"
                                value-field="id"
                                :disabled="!model.doencaCardiaca || model.recusaCadastro"
                                :validations="model.doencaCardiaca == true ? validations.doencasCardiacas : {}"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Problemas nos rins"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-radio-group
                                v-model="model.problemasRins"
                                label="Tem ou teve?"
                                @change="resetProblemasRinsQuais()"
                                :disabled="model.recusaCadastro"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="8">
                            <rkm-form-checkbox-group
                                :options="form.problemasRins"
                                label="Quais problemas?"
                                name="problemasRins"
                                text-field="descricao"
                                v-model="model.problemasRinsQuais"
                                value-field="id"
                                :disabled="!model.problemasRins || model.recusaCadastro"
                                :validations="model.problemasRins == true ? validations.problemasRins : {}"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Doença respiratória/no pulmão"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-radio-group
                                v-model="model.doencaRespiratoria"
                                label="Tem?"
                                @change="resetDoencaRespiratoriaQuais()"
                                :disabled="model.recusaCadastro"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="8">
                            <rkm-form-checkbox-group
                                :options="form.doencasRespiratorias"
                                label="Quais doenças respiratórias?"
                                inline
                                name="doencasRespiratorias"
                                text-field="descricao"
                                v-model="model.doencaRespiratoriaQuais"
                                value-field="id"
                                :disabled="!model.doencaRespiratoria || model.recusaCadastro"
                                :validations="model.doencaRespiratoria == true ? validations.doencaRespiratoria : {}"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Tratamento psiquiátrico ou teve internação por problema de saúde mental"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-radio-group
                                v-model="model.tratamentoSaudeMental"
                                label="Fez ou faz?"
                                :disabled="model.recusaCadastro"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                label="Data da internação"
                                :max-date="form.dataAtual"
                                v-model="model.tratamentoSaudeMentalInternacaoData"
                                :disabled="!model.tratamentoSaudeMental || model.recusaCadastro"
                                right
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                label="Data da alta"
                                :max-date="form.dataAtual"
                                :min-date="minDatetSaudeMentalAlta"
                                v-model="model.tratamentoSaudeMentalAltaData"
                                :disabled="!model.tratamentoSaudeMentalInternacaoData || model.recusaCadastro"
                                right
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                label="Período (em dias)"
                                v-model="diasTratamentoSaude"
                                disabled
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-area
                    title="Acamado"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-radio-group
                                v-model="model.acamado"
                                label="Está acamado?"
                                :disabled="model.recusaCadastro"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-area
                    title="Domiciliado"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-radio-group
                                v-model="model.domiciliado"
                                label="Está domiciliado?"
                                :disabled="model.recusaCadastro"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Plantas medicinais"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-radio-group
                                v-model="model.plantasMedicinais"
                                label="Usa plantas medicinais?"
                                @change="resetPlantasMedicinaisQuais()"
                                :disabled="model.recusaCadastro"

                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="6">

                            <rkm-form-input
                                label="Quais"
                                v-model="model.plantasMedicinaisQuais"
                                :disabled="!model.plantasMedicinais || model.recusaCadastro"
                                :validations="model.plantasMedicinais == true ? validations.plantasMedicinaisQuais : {}"
                                uppercase
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-area
                    title="Práticas integrativas e complementares"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-radio-group
                                v-model="model.praticasIntegrativas"
                                label="Usa práticas?"
                                :disabled="model.recusaCadastro"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="9">
                <rkm-area
                    title="Outras condições de saúde"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-input
                                label="1 - Qual?"
                                v-model="model.outrasCondicoesPrimaria"
                                :validations="validations.outrasCondicoesPrimaria"
                                :disabled="model.recusaCadastro"
                                uppercase
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                label="2 - Qual?"
                                v-model="model.outrasCondicoesSecundaria"
                                :validations="validations.outrasCondicoesSecundaria"
                                :disabled="model.recusaCadastro"
                                uppercase
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                label="3 - Qual?"
                                v-model="model.outrasCondicoesTerciaria"
                                :validations="validations.outrasCondicoesTerciaria"
                                :disabled="model.recusaCadastro"
                                uppercase
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>

//Moment
import moment from 'moment'

export default {
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                internacao: { required: true },
                doencasCardiacas: {
                    required: true,
                },
                doencaRespiratoria: {
                    required: true,
                },
                problemasRins: {
                    required: true,
                },
                maternidadeReferencia: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.form.termosInvalidos,
                },
                internacaoMotivo: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.form.termosInvalidos,
                    required: this.model.internacao
                },
                plantasMedicinaisQuais: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.form.termosInvalidos,
                },
                outrasCondicoesPrimaria: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.form.termosInvalidos,
                },
                outrasCondicoesSecundaria: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.form.termosInvalidos,
                },
                outrasCondicoesTerciaria: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.form.termosInvalidos,
                },
            }
        },
        minDate() {
            return moment(this.form.dataAtual, 'DD/MM/YYYY').subtract(1, 'year').format('DD/MM/YYYY');
        },
        minDatetSaudeMentalAlta() {
            return moment(this.model.tratamentoSaudeMentalInternacaoData).format('DD/MM/YYYY');
        },
        diasTratamentoSaude() {

            let dias = null;

            if (this.model.tratamentoSaudeMentalInternacaoData && this.model.tratamentoSaudeMentalAltaData) {

                const internacaoData = moment(this.model.tratamentoSaudeMentalInternacaoData);
                const altaData = moment(this.model.tratamentoSaudeMentalAltaData);

                dias = Math.abs(internacaoData.diff(altaData, 'days'));
            }

            return dias;
        }
    },
    methods: {
        calcularIdade() {
            const dataAtual = moment(this.form.dataAtual);
            const idade = dataAtual.diff(this.model.dataNascimento, 'years');

            if (!this.model.gestante && idade < 9
                || !this.model.gestante &&  idade > 60) {

                this.model.gestante = null
                this.resetMaternidadeReferencia()

                return true;
            }

            return false;
        },
        resetMaternidadeReferencia() {

            if (!this.model.gestante) {
                this.model.maternidadeReferencia = null
            }
        },
        resetInternacaoMotivo() {

            if (!this.model.internacao) {
                this.model.internacaoMotivo = null
            }
        },
        resetDoencaCardiacaQuais() {

            if (!this.model.doencaCardiaca) {
                this.model.doencaCardiacaQuais = []
            }
        },
        resetProblemasRinsQuais() {

            if (!this.model.problemasRins) {
                this.model.problemasRinsQuais = []
            }
        },
        resetDoencaRespiratoriaQuais() {

            if (!this.model.doencaRespiratoria) {
                this.model.doencaRespiratoriaQuais = []
            }
        },
        resetPlantasMedicinaisQuais() {

            if (!this.model.plantasMedicinais) {
                this.model.plantasMedicinaisQuais = null
            }
        }
    },
}
</script>